module.exports = __webpack_public_path__ + "img/92151.677f413b.svg";